import "./Footer.css";
import Button from "../../../../../shared/components/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  saveAnswerRequest,
  fetchExamQuestionRequest,
  setCurrentQuestionIndex,
  setActiveSection,
  updateQuestionStatus,
} from "../../../../../redux/exam/examSlice";

const Footer = () => {
  const dispatch = useDispatch();
  const {
    currentQuestionIndex,
    questionsData,
    testDetails,
    paperId,
    testType,
    loading,
  } = useSelector((state) => state.examSlice);

  const currentQuestion = questionsData[currentQuestionIndex];

  const isLastQuestion =
  currentQuestionIndex === questionsData.length - 1;

  const getSectionKey = (q) => `${q.subject} ${q.section_name || ""}`.trim();

  const handleSaveNext = (e) => {
    e.preventDefault();

    if (loading) return;

    const currentQ = currentQuestion;
    if (!currentQ) return;

    const validPaperId = paperId;
    const validPaperType = testDetails?.paper_type || testType?.id;

    // if (!validPaperId) {
    //   console.error("paperId is missing!", { testDetails, paperId });
    //   alert("Exam data missing. Please restart test.");
    //   return;
    // }

    // 1. Save current answer
    dispatch(
      saveAnswerRequest({
        // paper_type: validPaperType,
        // paper_id: validPaperId,
          paper_type: testDetails?.paper_type || testType?.id,
      paper_id: paperId,
        qid: currentQ?.qid,
        // option_id: currentQ?.selectedOption || "",
        test_id: testDetails?.testId,
        set_id: testDetails?.setId,
        time: currentQ?.time,
          ...(currentQ.type === "Integer-Type"
        ? { option_int: currentQ.integerAnswer || "" }
        : { option_id: currentQ.selectedOption || "" }),
      })
    );
    const nextIndex = currentQuestionIndex + 1;
if (nextIndex >= questionsData.length) return;
const nextQuestion = questionsData[nextIndex];
dispatch(setCurrentQuestionIndex(nextIndex));
const nextSection = getSectionKey(nextQuestion);
const currSection = getSectionKey(currentQ);

if (nextSection !== currSection) {
  dispatch(setActiveSection(nextSection));
}
  };

  const handlePrevious = () => {
    if (currentQuestionIndex === 0) return;

    const prevIndex = currentQuestionIndex - 1;
    const prevQuestion = questionsData[prevIndex];

    const validPaperId = testDetails?.paper_id || paperId;
    const validPaperType = testDetails?.paper_type || testType?.id;

    dispatch(setCurrentQuestionIndex(prevIndex));

    const prevSection = getSectionKey(prevQuestion);
    const currSection = getSectionKey(currentQuestion);
    if (prevSection !== currSection) {
      dispatch(setActiveSection(prevSection));
    }

    dispatch(
      fetchExamQuestionRequest({
        paperId: validPaperId,
        paperType: validPaperType,
        qid: prevQuestion.qid,
        testId: testDetails?.testId,
      })
    );
  };

  const handleMarkReview = () => {
    if (currentQuestion) {
      dispatch(
        updateQuestionStatus({
          qid: currentQuestion.qid,
          markReview: true,
        })
      );
    }
  };

  return (
    <div className="footer-container">
      <div className="footer-left">
        <Button
          title="Previous"
         variant="outlined"
         color="primary"
          className="footer-btn outlined-btn"
          onClick={handlePrevious}
          disabled={currentQuestionIndex === 0}
        />
        <Button
          title="Mark for Review"
           variant="outlined"
         color="primary"
          className="footer-btn outlined-btn"
          onClick={handleMarkReview} // Ensure this triggers the API call
        />
      </div>

      <div className="footer-right">
        <Button
          // title="Save & Next"
          variant="contained"
          color="error"
           title={isLastQuestion ? "Save" : "Save & Next"}
          className="footer-btn contained-error"
          onClick={handleSaveNext}
          // disabled={
          //   currentQuestionIndex === questionsData.length - 1 || loading
          // }
          disabled={loading}

        />
      </div>
    </div>
  );
};

export default Footer;
